import React, { createElement, HTMLAttributes } from 'react';
import cn from 'classnames';

import ICONS, { YubiIconTypes } from './svgs';

import styles from './YubiIcon.module.scss';
import { colors, YubiColorTypes } from '../../style';

export type YubiIconSizes =
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'xxl'
  | 'x3'
  | 'x4'
  | 'x5'
  | 'x6'
  | 'x7'
  | 'x8'
  | 'x9';
export type RotateValues = 0 | 90 | 180 | 270 | 360;
export interface YubiIconProps extends HTMLAttributes<SVGElement> {
  icon: YubiIconTypes;
  rotate?: RotateValues;
  spin?: boolean;
  height?: string;
  width?: string;
  size?: YubiIconSizes;
  display?: string;
  color?: YubiColorTypes | string;
  title?: string;
  clickable?: boolean;
}

const SIZES = {
  sm: '1rem',
  md: '1.5rem',
  lg: '1.75rem',
  xl: '2rem',
  xxl: '2.5rem',

  x3: '3rem',
  x4: '4rem',
  x5: '5rem',
  x6: '6rem',
  x7: '7rem',
  x8: '8rem',
  x9: '9rem',
};

const rotateClassMap: { [key in RotateValues]: string } = {
  0: 'rotate__zero',
  90: 'rotate__ninety',
  180: 'rotate__one-eighty',
  270: 'rotate__two-seventy',
  360: 'rotate__three-sixty',
};

function YubiIcon({
  icon,
  spin = false,
  rotate = 0,
  height,
  width,
  size = 'sm',
  color = colors.yubiGreen,
  title,
  clickable = false,
  ...props
}: YubiIconProps) {
  const iconClass = cn(styles['yubi-icon'], [styles[rotateClassMap[rotate]]], {
    [styles.spin]: spin,
    [styles.clickable]: clickable,
  });

  return (
    <div className={iconClass} title={title} data-testid={`yubi-icon-${icon}`}>
      {createElement(ICONS[icon], {
        width: width || SIZES[size],
        height: height || SIZES[size],
        fill: color,
        'data-icon': icon,
        ...props,
      })}
    </div>
  );
}

export default YubiIcon;
